import {
  OnStepEnterExitArgs,
  ScrollGraphic,
  ScrollRoot,
  ScrollStep,
  ScrollSteps,
} from '@/components/microstory/scroll';
import { CenteredStoryText, StoryText } from '@/components/microstory/text';
import { SunriseChart, SunriseChartData } from '@/components/sunrise-chart';
import { useNumberFormatting } from '@/utils/use-number-formatting';
import { Trans, t } from '@lingui/macro';
import { useState } from 'react';

export function TheOtherClimateCrisis2023Chapter4() {
  const formatValue = useNumberFormatting('percent');

  const [chartData, setChartData] = useState<SunriseChartData>();

  const handleStepEnter = async (evt: OnStepEnterExitArgs<SunriseChartData>) => {
    if (evt.data) setChartData(evt.data);
  };

  return (
    <>
      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-4.text-1`}>
          The good news is that many more people are aware of climate change today globally than
          they were ~15 years ago.
        </Trans>
      </CenteredStoryText>

      <ScrollRoot>
        <ScrollGraphic>
          <SunriseChart data={chartData} formatValue={formatValue} />
        </ScrollGraphic>

        <ScrollSteps onStepEnter={handleStepEnter}>
          <ScrollStep
            data={[
              {
                label: t({
                  id: 'the-other-climate-crisis-2023.chapter-4.chart-top-left-label',
                  message: '% People aware of climate change',
                }),
                data: [
                  {
                    label: t({
                      id: 'the-other-climate-crisis-2023.chapter-4.chart-sub-label-1',
                      message: 'In 2008:',
                    }),
                    value: 0.56,
                  },
                ],
              },
            ]}
          >
            <StoryText>
              <Trans id="the-other-climate-crisis-2023.chapter-4.text-2">
                In 2008 this was just 56% of people.
              </Trans>
            </StoryText>
          </ScrollStep>

          <ScrollStep
            data={[
              {
                label: t({
                  id: 'the-other-climate-crisis-2023.chapter-4.chart-top-left-label',
                  message: '% People aware of climate change',
                }),
                data: [
                  {
                    label: t({
                      id: 'the-other-climate-crisis-2023.chapter-4.chart-sub-label-1',
                      message: 'In 2008:',
                    }),
                    value: 0.56,
                  },
                ],
              },
              {
                data: [
                  {
                    label: t({
                      id: 'the-other-climate-crisis-2023.chapter-4.chart-sub-label-2',
                      message: 'In 2023:',
                    }),
                    value: 0.8,
                    isApproximatValue: true,
                  },
                ],
              },
            ]}
          >
            <StoryText>
              <Trans id="the-other-climate-crisis-2023.chapter-4.text-3">
                Today, on average, 80% of people are aware of climate change.
              </Trans>
            </StoryText>
          </ScrollStep>
        </ScrollSteps>
      </ScrollRoot>

      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-4.text-4`}>
          There has also been modest growth in climate understanding across all age groups in the
          same period.
        </Trans>
      </CenteredStoryText>

      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-4.text-5`}>
          But climate knowledge globally falls far short of what is needed. A failure to comprehend
          the climate crisis means an inability to respond to it.
        </Trans>
      </CenteredStoryText>

      <CenteredStoryText>
        <Trans id={`the-other-climate-crisis-2023.chapter-4.text-6`}>
          Climate education can help strengthen the demand for change.
        </Trans>
      </CenteredStoryText>
    </>
  );
}
